import { useTheme } from '@mui/material';
import { FieldRenderBlockProp } from '../..';
import ListAvatarBlock from '../../_utils/list-avatar-block';

export default function SignalBlockRenderer(props: FieldRenderBlockProp) {
  const theme = useTheme();

  if (!props.data?.signal) return <></>;

  return (
    <ListAvatarBlock
      title={props.data.signal?.title}
      value={props.data.signal?.value}
      e={props}
    />
  );
}
